import { GradientBorderCard } from 'components/Cards/GradientBorderCard';
import { FormContent } from 'screens/Forms/FormContent';

export const Recommendations: React.FC<{ title: string }> = ({ title }) => {
  return (
    <div className="get-started-recommendations-container">
      <div className="get-recommendations-container">
        <GradientBorderCard borderType="full" width="100%">
          <div className="inner-gradient-box">
            <span className="h3-dtm">{title}</span>
            {/* No redirect on a missing form: the form is only part of this page. */}
            <FormContent form="get-started-bottom-button" />
          </div>
        </GradientBorderCard>
      </div>
    </div>
  );
};
